import {ProvidingListApplication} from '../../../shared/models/api';
import {Document} from './documents/model';

export const getProfileApplicationsAndDocumentsFilterName = (key: string | number | boolean, name: string = '') => {
  const modifiedKey = '' + key;
  if (name) {
    return `${name}.${modifiedKey}`;
  }
  if (typeof key === 'boolean') {
    if (key) return 'signed';
    return 'unsigned';
  }
  return modifiedKey;
};

export const filterApplicationsList =
  (filter: {status: {[key: string]: boolean}; typeApplication: {[key: string]: boolean}}) =>
  (item: ProvidingListApplication) => {
    let isMatch = true;
    if (isMatch && filter?.status && !Object.values(filter.status).every((status) => !status)) {
      isMatch = filter.status[getProfileApplicationsAndDocumentsFilterName(item.statusId || '')];
    }
    if (
      isMatch &&
      filter?.typeApplication &&
      !Object.values(filter.typeApplication).every((typeApplication) => !typeApplication)
    ) {
      isMatch = filter.typeApplication[getProfileApplicationsAndDocumentsFilterName(item.typeApplicationId || '')];
    }
    return isMatch;
  };

export const filterDocumentsList =
  (filter: {status: {[key: string]: boolean}; documentType: {[key: string]: boolean}}) => (item: Document) => {
    let isMatch = true;
    if (isMatch && filter?.status && !Object.values(filter.status).every((status) => !status)) {
      isMatch = filter.status[getProfileApplicationsAndDocumentsFilterName(item.isSigned)];
    }
    if (isMatch && filter?.documentType && !Object.values(filter.documentType).every((documentType) => !documentType)) {
      isMatch = filter.documentType[getProfileApplicationsAndDocumentsFilterName(item.type || '')];
    }
    return isMatch;
  };
